import React, { useState, useEffect } from 'react';

// Use as HOC when the component does not support SSR or it makes no sense to render in on server.
// Takes care of clean hydration: https://reactjs.org/docs/react-dom.html#hydrate
const clientOnly = BaseComponent => props => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  });

  if (!isClient) {
    return null;
  }

  return <BaseComponent {...props} />;
};

export default clientOnly;
